import '../stylesheet/element-reset.scss'
import '../stylesheet/element-variables.scss'

import Scrollbar from 'element-ui/lib/scrollbar'
import Vue from 'vue'
import {
    Autocomplete,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    ButtonGroup,
    Card,
    Checkbox,
    CheckboxGroup,
    Col,
    DatePicker,
    Dialog,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Form,
    FormItem,
    Image,
    Input,
    InputNumber,
    Loading,
    Menu,
    MenuItem,
    MenuItemGroup,
    Message,
    MessageBox,
    Notification,
    Option,
    OptionGroup,
    Pagination,
    Radio,
    RadioButton,
    RadioGroup,
    Row,
    Select,
    Submenu,
    Switch,
    Table,
    TableColumn,
    TimePicker,
    TimeSelect,
    Tooltip,
    Upload
} from 'element-ui'

function elementImport() {
    Vue.use(Scrollbar)
    Vue.use(Image)
    Vue.use(Autocomplete)
    Vue.use(Upload)
    Vue.use(Menu)
    Vue.use(Submenu)
    Vue.use(MenuItem)
    Vue.use(MenuItemGroup)
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Pagination)
    Vue.use(Dialog)
    Vue.use(Input)
    Vue.use(InputNumber)
    Vue.use(Switch)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(OptionGroup)
    Vue.use(Button)
    Vue.use(ButtonGroup)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(DatePicker)
    Vue.use(TimeSelect)
    Vue.use(TimePicker)
    Vue.use(Tooltip)
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Card)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Row)
    Vue.use(Col)

    Vue.use(Loading.directive)

    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message

    Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
}

export default elementImport
